import { createContext, useState, useEffect, useContext } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

export const useSocketContext = () => useContext(SocketContext);

export const SocketContextProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [socketId, setSocketId] = useState(null);
  const activityUrl = "https://activity-point-472db927ee51.herokuapp.com";

  useEffect(() => {
    const socket = io(activityUrl);

    socket.on("connect", () => {
      // console.log("Connected with ID:", socket.id);
      setSocketId(socket.id);
    });

    setSocket(socket);

    return () => {
      socket.close();
      socket.disconnect();
      setSocket(null);
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, socketId }}>
      {children}
    </SocketContext.Provider>
  );
};
